<template lang="pug">
transition(name="g_fade-shrink")
	.modal__mask(@keydown="keydown")
		form.modal(@submit.prevent="submit" v-if="true")
			.modal__header
				button.button--ghost.button--icon-only.button--modal-close(v-show="showCloseButton", @click="close") &times;
				slot(name="header")
					h3: label {{ title }}

			.modal__content
				slot

			.modal__footer(v-show="!hideFooter")
				slot.actions(name="actions")
					button.button.button--primary(@click="close") OK
</template>

<script>
import _ from "lodash";
import Component, { mixins } from "vue-class-component";
import Closable from "@/mixins/Closable.js";

@Component({
	props: {
		title: {
			default: "Title"
		},
		hideFooter: {
			default: false
		},
		showCloseButton: {
			default: true
		}
	}
})
class Modal extends mixins(Closable) {
	mounted() {
		this.focusFirstInput();
	}

	focusFirstInput() {
		const inputs = this.$el.querySelectorAll(
			"input, a[href], button, select, textarea"
		);
		if (inputs.length > 0) {
			const first = _.head(inputs);
			const last = _.last(inputs);
			if (first.focus) {
				first.focus();
			}
			if (first.select) {
				first.select();
			}
			first.addEventListener("keydown", ev => {
				if (ev.which == 9 && ev.shiftKey) {
					ev.preventDefault();
					last.focus();
				}
			});
			last.addEventListener("keydown", ev => {
				if (ev.which == 9 && !ev.shiftKey) {
					ev.preventDefault();
					first.focus();
				}
			});
		}
	}

	submit() {
		this.$emit("submit");
	}
}
export default Modal;
</script>

<style lang="stylus">
.modal__mask
	position fixed
	z-index 49950
	// opacity 1
	top 0
	left 0
	width 100%
	height 100%
	background-color rgba(0, 0, 0, 0.5)
	display flex
	// transition opacity .2s ease
	flex-direction column
	justify-content center
	align-items center

	.modal
		position relative
		flex-direction column
		max-width 600px
		min-width 300px
		margin 0px auto
		background-color $light-bg-color
		border solid 1px $dark-bg-bold-text-color
		box-shadow 0 2px 8px rgba(0, 0, 0, 0.33)

		.modal__header
			position relative
			padding 1em
			text-align center

			h1, h2, h3, h4, h5, h6
				margin 0

			.button--modal-close
				opacity 0.5
				display flex
				justify-content center
				align-items center
				position absolute
				right 0
				top 0
				bottom 0
				width 2em
				height 2em
				outline 0

				&:focus, &:active
					outline 0

				// &:hover
				// 	opacity 1

		.modal__content
			padding 0.5em 1em

			p:first-of-type
				margin-top 0

		.modal__footer
			display block
			width 100%
			padding 1em

			.actions
				display block
				text-align center

			.button
				margin-left 0.5em
</style>
